import React from 'react';

const AlertCircleWithBackdrop = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <circle cx="10" cy="10" r="10" fill="#F69E9E" />
      <circle cx="10" cy="10" r="6" fill="#E92C2C" />
      <mask
        id="mask0_4642_53990"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="4"
        y="4"
        width="12"
        height="12"
      >
        <rect x="4" y="4" width="12" height="12" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4642_53990)">
        <path
          d="M10 10.9922C9.85833 10.9922 9.73958 10.9443 9.64375 10.8484C9.54792 10.7526 9.5 10.6339 9.5 10.4922V6.99219C9.5 6.85052 9.54792 6.73177 9.64375 6.63594C9.73958 6.5401 9.85833 6.49219 10 6.49219C10.1417 6.49219 10.2604 6.5401 10.3562 6.63594C10.4521 6.73177 10.5 6.85052 10.5 6.99219V10.4922C10.5 10.6339 10.4521 10.7526 10.3562 10.8484C10.2604 10.9443 10.1417 10.9922 10 10.9922ZM10 13.4922C9.85833 13.4922 9.73958 13.4443 9.64375 13.3484C9.54792 13.2526 9.5 13.1339 9.5 12.9922C9.5 12.8505 9.54792 12.7318 9.64375 12.6359C9.73958 12.5401 9.85833 12.4922 10 12.4922C10.1417 12.4922 10.2604 12.5401 10.3562 12.6359C10.4521 12.7318 10.5 12.8505 10.5 12.9922C10.5 13.1339 10.4521 13.2526 10.3562 13.3484C10.2604 13.4443 10.1417 13.4922 10 13.4922Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default AlertCircleWithBackdrop;
